module.exports = __webpack_public_path__ + "6edd9f04a907274b0f9bb67112c7074a.pdf";